import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CTASection } from '../components/CTASection';
export function SalesPage() {
  return <main className="w-full min-h-screen bg-cream font-sans" data-id="element-251">
      <HeroSection data-id="element-252" />
      <ProblemSection data-id="element-253" />
      <MechanismSection data-id="element-254" />
      <ProductSection data-id="element-255" />
      <TestimonialsSection data-id="element-256" />
      <OfferSection data-id="element-257" />
      <GuaranteeSection data-id="element-258" />
      <CTASection data-id="element-259" />
    </main>;
}